import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import spaceActions from 'actions/spaces/actions'
import moment from 'moment'
import LoadingOverlay from 'components/shared/loaders/loading-overlay'
import SpaceActionForm from './space-action-form'

const SpaceAction = ({
  venueId,
  setAction,
  spaceId,
  action,
  space,
  fetchSpaceDetails,
  notification: { type },
  createNewSpace,
  editSpace,
  loading,
}) => {
  const title = action === 'add' ? 'List a Space' : 'Edit Space'

  useEffect(() => {
    spaceId && fetchSpaceDetails(spaceId)
  }, [spaceId])

  useEffect(() => {
    if (type === 'success') setAction('view')
  }, [type])
  return (
    <LoadingOverlay loading={loading}>
      <div className="flex items-center text-primary-orange cursor-pointer mb-4">
        <i className="fa fa-caret-left mr-3" aria-hidden="true"></i>
        <p className="text-xs" onClick={() => setAction('view')}>
          Back to Venue Spaces
        </p>
      </div>
      <div className="header py-3">
        <h5 className="font-bold py-1 text-primary-black text-3xl">{title}</h5>
        <p className="py-1 text-gray-600">
          Input the information of the Space/s available in this venue.
          Space/s are the hot desk, meeting rooms, private offices, event spaces
        </p>
      </div>
      {action === 'add' && (
        <SpaceActionForm
          initialValues={{
            venue_id: venueId,
            area_unit: 'sqft',
            floor_level: 'low_floor',
          }}
          onSubmit={(values) => createNewSpace(values)}
          form="merchant-add-space"
        />
      )}
      {action === 'edit' && (
        <SpaceActionForm
          initialValues={{
            spaceId,
            ...space,
            area_unit: space.area_unit || 'sqft',
            date_available: space?.date_available
              ? moment(space.date_available).format('YYYY-MM-DD')
              : '',
            floor_level: space.floor_level ?? 'low_floor',
          }}
          onSubmit={(values) => editSpace(values)}
          form="merchant-edit-space"
        />
      )}
    </LoadingOverlay>
  )
}

SpaceAction.propTypes = {
  setAction: PropTypes.func,
  venueId: PropTypes.number,
  spaceId: PropTypes.number,
  action: PropTypes.string,
  createNewSpace: PropTypes.func,
  fetchSpaceDetails: PropTypes.func,
  editSpace: PropTypes.func,
  space: PropTypes.object,
  notification: PropTypes.object,
  loading: PropTypes.bool,
}

const mapStateToProps = ({ space, notification }) => ({
  loading: space.fetching,
  space: space.spaceDetails,
  notification,
})

const mapDispatchToProps = {
  createNewSpace: spaceActions.createNewSpace,
  fetchSpaceDetails: spaceActions.fetchSpaceDetails,
  editSpace: spaceActions.editSpace,
}

export default connect(mapStateToProps, mapDispatchToProps)(SpaceAction)
